import React, {useRef, useState} from 'react';
import {Navbar, Footer, Container, SearchFormLeft} from '../../components';
import cn from 'classnames';
import ImageGallery from './ImageGallery/ImageGallery';
import styles from './styles.module.css';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Overview from "./Overview";
import Description from "./Description";
import RoomChoices from "./RoomChoices";
import Amenities from "./Amenities";
import GuestReviews from "./GuestReviews";
import GuestComments from "./GuestComments";

const images = [
  { url: './assets/images/venice.jpg' },
  { url: './assets/images/medine.png' },
  { url: './assets/images/medine-1.png' },
  { url: './assets/images/medina-2.jpg' },
  { url: './assets/images/paris.jpg' },
];

const Hotel = () => {
  const [activeTab, setActiveTab] = useState('description');
  const descriptionRef = useRef(null);
  const roomRef = useRef(null);
  const amenitiesRef = useRef(null);
  const attractionsRef = useRef(null);
  const scrollToRefObject = (ref) => window.scrollTo(0, ref.current.offsetTop-50);
    return (
    <>
      <Navbar sticky isColored/>
      <ImageGallery images={images} />
      <div className={styles.topBar}>
        <Container>
            <Grid fluid>
                <Row>
                    <Col xs={12} md={4} lg={4}>
                        <div className={styles.leftSide}>
                            <SearchFormLeft/>
                        </div>
                        <GuestReviews/>
                        <GuestComments/>
                    </Col>
                    <Col xs={12} md={8} lg={8}>
                        <div className={styles.topBarInner}>
                            {[{name:'description' , ref:descriptionRef}, {name:'room choices',ref: roomRef}, {name:'hotel amenities',ref: amenitiesRef}, {name:'attractions',ref:attractionsRef}].map((item, index) => (
                                <button
                                    onClick={() => {setActiveTab(item.name) ; scrollToRefObject(item.ref); }}
                                    className={cn([styles.topBarLink, item.name === activeTab && styles.activeLink])}
                                    key={index}
                                >
                                    {item.name}
                                </button>
                            ))}
                        </div>
                        <Overview/>
                        <Description refProp={descriptionRef} />
                        <RoomChoices refProp={roomRef} />
                        <Amenities refProp={amenitiesRef} />
                    </Col>
                </Row>
            </Grid>

        </Container>
      </div>

      <Footer />
    </>
  );
};

export default Hotel;
